import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { first, find, orderBy, reduce, each } from 'lodash';
import Fa from 'react-fontawesome';
import pluralize from 'pluralize';
import {
  DropdownButton, MenuItem, ControlLabel, FormGroup,
  OverlayTrigger, Tooltip,
} from 'react-bootstrap';


class OwnerSelector extends Component {
  constructor() {
    super();
    this.state = {};
    this.selectOwner = this.selectOwner.bind(this);
  }

  componentDidMount() {
    this.checkProps(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.checkProps(nextProps);
  }

  getRoleName(role) {
    const { isAccount } = this.props;
    if (role === 'salespeople') {
      return isAccount ? 'Account Owner' : 'Opportunity Owner';
    }
    if (role === 'accountManagers') {
      return 'Account Managers';
    }
    if (role === 'salesManagers') {
      return 'Sales Managers';
    }
    return role;
  }

  /*
  checkProps(props) {
    // ensure we always select somthing
    if (!props.selectedOwner) {
      let option = null;
      const { owners, sfOwner } = props;

      if (props.isOwner || !props.verified) {
        if (props.authSignature && props.authEmailVerified) {
          option = props.authSignature;
        }
      } else {
        // default to opportunity owner email, then auth, then first
        if (sfOwner) {
          option = find(owners, { email: sfOwner.email });
        }
        if (!option && props.authSignature) {
          option = props.authSignature;
        }
        if (!option) {
          option = first(props.owners);
        }
      }
      if (!option) {
        // default to SC email
        option = find(props.collectorSignatures, { is_collector: true });
      }
      if (option) {
        props.onSelect(option);
      }
    }
  }
  */

  checkProps(props) {
    // ensure we always select somthing
    if (!props.selectedOwner) {
      const { owners, sfOwner, collector, collectorSignatures, dynamicSenders } = props;
      let option = find(collectorSignatures, { is_collector: true }) || find(collectorSignatures, { is_collector: true }) || first(collectorSignatures);
      const useSalesRepsEmailFirst = collector && collector.is_sales_rep_first === true;

      if (useSalesRepsEmailFirst || !option) {
        // for dynamic sender, select the first match, because order matter
        option = sfOwner ? find(dynamicSenders, { email_confirmed: true }) || find(owners, { email: sfOwner.email, email_confirmed: true }) || option : option;
      }
      props.onSelect(option);
    }
  }

  selectOwner(owner) {
    if (owner) {
      this.props.onSelect(owner, true);
    }
  }

  renderOwner(owner) {
    const isCollector = owner.is_collector ? (<span><Fa name="star" className="text-warning" /> </span>) : null;

    const isDynamicSender = owner.source === 'dynamicSender';
    const automationQualidfied = owner.automation_qualidfied === true;
    let warning = null;
    /*
    if (isDynamicSender && !automationQualidfied) {
      const tooltip = (
        <Tooltip id={owner.id}>
          <div>This dynamic sender does not match trigger conditions of any automation group.</div>
        </Tooltip>
      );
      warning = (
        <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={tooltip}>
          <span><Fa name="exclamation-triangle" className="text-warning" /></span>
        </OverlayTrigger>  
      );
    }
    */
    return (
      <span>{isCollector} {owner.name} <code>{owner.email}</code> {warning}</span>
    );
  }

  render() {
    const {
      owners, selectedOwner,
      collector,
      collectorSignatures,
      authSignature,
      dynamicSenders,
    } = this.props;

    if (!collector) {
      return null;
    }
    // const isOwner = this.isOwner(this.props);
    // either owner or we cannot find any valid owner emails, then we will send from current login user email
    let emails = [];
    let currentRole = null;
    const menus = reduce(orderBy(owners, ['role'], ['asc']), (items, owner) => {
      if (owner.role !== currentRole) {
        items.push({
          isHeader: true,
          name: this.getRoleName(owner.role),
          id: owner.role,
        });
        currentRole = owner.role;
      }
      items.push(owner);
      return items;
    }, []);
    emails = menus;


    if (dynamicSenders && dynamicSenders.length > 0) {
      emails.push({
        isHeader: true,
        name: pluralize('Dynamic Sender', dynamicSenders),
        id: 'dynamicSender',
      });

      each(dynamicSenders, (dynamicSender) => {
        emails.push(dynamicSender);
      });
    }

    if (collectorSignatures && collectorSignatures.length > 0) {
      emails.push({
        isHeader: true,
        name: 'Survey Colector',
        id: collector.collector_id,
      });

      each(collectorSignatures, (collectorSignature) => {
        emails.push(collectorSignature);
      });
    }

    // is my email in the list
    
    if (authSignature) {
      emails.push({
        isHeader: true,
        name: 'YOU',
        id: 'you',
      });
      emails.push({
        ...authSignature,
        needVerification: !authSignature.email_confirmed,
        isUser: true,
      });
    }

    if (emails.length <= 1) {
      return null;
    }

    const activeOwner = selectedOwner ? find(emails, { id: selectedOwner.id }) : null;
    const useSalesRepsEmailFirst = collector && collector.is_sales_rep_first === true;
    // owner first?
   
    let notes = [];

    
    if (activeOwner && activeOwner.is_collector && useSalesRepsEmailFirst) {
      notes.push({
        key: 'one',
        node: (<>This collector sender information is set to <strong>Sales Rep First</strong>, meaning it will use the the opportunity&rsquo;s sales reps email when available.</>)
      });
    } else if (activeOwner && activeOwner.source === 'dynamicSender' && !activeOwner.automation_qualidfied) {
      notes.push({
        key: 'two',
        node: (<>This dynamic sender does not match the trigger conditions of any automation group.</>),
      });
    }
    if (activeOwner && activeOwner.replaced_email) {
      notes.push({
        key: 'three',
        node: (<>Email address will be replaced with <code>{activeOwner.replaced_email}</code></>),
      });
    }

    let note = null;

    if (notes.length) {
      note = (
        <div className="text-warning" style={{ marginTop: '10px' }}>
          {notes.length > 1 &&
            <div>
              <div><Fa name="exclamation-triangle" /> Please notice that:</div>
              <ul>
                {notes.map((n) => {
                  return (
                    <li key={n.key}>{n.node}</li>
                  );
                })}
              </ul>
            </div>
          }
          {notes.length === 1 &&
            <div>
              <div><Fa name="exclamation-triangle" /> {notes[0].node}</div>  
            </div>
          }
        </div>
      );
    }


    return (
      <FormGroup>
        <ControlLabel>Emails will be sent from:</ControlLabel>
        <div>
          <DropdownButton
            dropup
            onSelect={this.selectOwner}
            title={activeOwner ? this.renderOwner(activeOwner) : 'Select Email'}
            id="owner-selector-period"
            bsStyle="default"
          >
            {emails.map((menu) => {
              if (menu.isHeader) {
                return (
                  <MenuItem header key={menu.id}>
                    {menu.name}
                  </MenuItem>
                );
              }
              return (
                <MenuItem
                  active={activeOwner ? menu.id === activeOwner.id : false}
                  key={menu.id}
                  eventKey={menu}
                >
                  {this.renderOwner(menu)}
                </MenuItem>
              );
            })}
          </DropdownButton>
        </div>
        {note}
      </FormGroup>
    );
  }
}


OwnerSelector.propTypes = {
  verified: PropTypes.bool,
  isOwner: PropTypes.bool,
  owners: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    role: PropTypes.string,
    id: PropTypes.string,
  })),
  collectorSignatures:  PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    id: PropTypes.string,
  })),
  dynamicSenders:  PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    id: PropTypes.string,
  })),
  selectedOwner: PropTypes.shape({
    id: PropTypes.string,
    email: PropTypes.string,
  }),
  authEmailVerified: PropTypes.bool,
  authSignature: PropTypes.shape({}),
  onSelect: PropTypes.func,
  collector: PropTypes.shape({
    is_sales_rep_first: PropTypes.bool,
    from_email: PropTypes.string,
  }),
  sfOwner: PropTypes.shape({}),
  isAccount: PropTypes.bool,
};
OwnerSelector.defaultProps = {
  verified: false,
  isOwner: false,
  authEmailVerified: false,
  owners: [],
  collectorSignatures: [],
  dynamicSenders: [],
  onSelect: () => {},
  selectedOwner: null,
  authSignature: null,
  collector: null,
  sfOwner: null,
  isAccount: false,
};

// Retrieve data from store as props
function mapStateToProps() {
  return {
  };
}

export default connect(mapStateToProps)(OwnerSelector);
